'use strict'

import CloudDataConnector from '../api.js'
import Plot from './base.js'

export default class PlotTemperatureSeason extends Plot {
  constructor () {
    super('temperature-season')
  }

  async dataFunction (controller) {
    // Get data from API
    const [seasonResponse, normalResponse] = await Promise.all([
      new CloudDataConnector().getSeasonMeanTemperatures(controller.uiElements.station.val(), controller.uiElements.season.val()),
      new CloudDataConnector().getSeasonNormalTemperatures(controller.uiElements.station.val(), controller.uiElements.season.val())
    ])
    const height = controller.uiParams.height

    const seasonData = seasonResponse.sort((left, right) => left.year < right.year ? -1 : (left.year > right.year ? 1 : 0))
    const normalData = normalResponse[0]

    const seasonDataPoints = seasonData.map(item => item.sensor_2m)
    const normalDataPoints = seasonData.map(_ => normalData.sensor_2m)

    const seasonXaxis = seasonData.map(item => item.year)
    const normalXaxis = seasonData.map(item => item.year)

    // Return elements to give to Plotly
    return {
      data: [
        {
          x: seasonXaxis,
          y: seasonDataPoints,
          type: 'lines+marker',
          name: 'Température mesurée',
          marker: { color: '#ffac2b', size: 8 },
          line: { color: '#ffac2b', width: 1 }
        },
        {
          x: normalXaxis,
          y: normalDataPoints,
          mode: 'lines',
          name: 'Température normale',
          marker: { color: '#00bcd5', size: 8 },
          line: { color: '#00bcd5', width: 1 }
        }
      ],
      layout: {
        xaxis: { title: 'Année', autotick: false },
        yaxis: { title: 'Température (degrés Celsius)' },
        margin: { t: 0 },
        height
      }
    }
  }
}
